var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from 'events';
import { AppJsApi } from './../common/config';
import loadJs from '../common/loadjs';
import { createDeeplink } from '../common/scheme';
import { AppDownloadStatus } from '../../../common/constants';
import { debugLogger, errorLogger } from '../../debug';
import { AppPackage } from '../common/appInfo';
/**
 * 腾讯新闻下载器实现
 * 相关文档：https://docs.qq.com/doc/DSkZBbnhrR29LYk5s
 */
var NewsDownloader = /** @class */ (function (_super) {
    __extends(NewsDownloader, _super);
    function NewsDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'NewsDownloader';
        _this.opt = __assign({}, opt);
        var _a = _this.opt, appId = _a.appId, _b = _a.icon, icon = _b === void 0 ? 'http://res.imtt.qq.com/res_mtt/qbmoney/smpreal/SMP_1583834979221.png' : _b, filename = _a.filename, packagename = _a.packagename, url = _a.url, active = _a.active, xsreporturl = _a.xsreporturl;
        _this.newsAppInfo = {
            appId: appId || 'smpnews',
            apkUrl: url,
            packageName: packagename,
            logoUrl: icon,
            appName: filename,
            scheme: active,
            // actionCode: '', // （下载接口必填） 下载接口的操作码（1开始下载，2暂停下载）
            versionCode: 1,
            fileSize: 0,
            // autoInstall: '', // 是否自动安装（1为自动安装，默认为1）
            md5: 'd4f73a30b8a225e53c0d56e3e1167685',
            // 添加上报统计
            reportParam: {
                reportType: 1000,
                reportUrl: xsreporturl
            },
        };
        return _this;
    }
    NewsDownloader.prototype.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                window.newsDownloadStatus = {};
                window.downloadStatus = function (status, progress) {
                    window.newsDownloadStatus = {
                        status: status,
                        progress: parseInt(String(progress * 100), 10)
                    };
                    // 下载完成
                    if (status === 3) {
                        _this.emit('downloadsucc', status);
                    }
                };
                this.getAppInfo();
                // status
                // 0：未下载
                // 1：下载中
                // 2：暂停下载
                // 3：下载完成
                // 4：正在安装
                // 5：安装完成/已安装
                // 6：安装失败
                // 7：需更新
                // 8：下载任务等待中
                // 9：下载失败
                window.installCallback = function (status) {
                    if (status === 5) {
                        _this.emit('install', status);
                    }
                };
                return [2 /*return*/, loadJs([AppJsApi.NEWS])];
            });
        });
    };
    NewsDownloader.prototype.getAppInfo = function () {
        var _this = this;
        var _a;
        window.appInfoCallback = function (res) {
            _this.emit('appinfo', res);
        };
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentNews) === null || _a === void 0 ? void 0 : _a.getAppInfo) {
            window.TencentNews.getAppInfo('appInfoCallback');
        }
        else {
            errorLogger('异常:', 'getAppInfo', '无此方法');
        }
    };
    NewsDownloader.prototype.start = function () {
        var _a, _b;
        debugLogger('start', this.newsAppInfo);
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentNews) === null || _a === void 0 ? void 0 : _a.downloadApp_gdt) {
            var appInfo = __assign(__assign({}, this.newsAppInfo), { actionCode: 1 });
            window.TencentNews.invoke('downloadApp_gdt', JSON.stringify(appInfo), "downloadStatus");
            if ((_b = window === null || window === void 0 ? void 0 : window.TencentNews) === null || _b === void 0 ? void 0 : _b.checkAppStatus) {
                window.TencentNews.invoke('checkAppStatus', JSON.stringify(this.newsAppInfo), 'downloadStatus');
            }
        }
        else {
            this.emit('error', status);
            errorLogger('异常:', 'downloadApp_gdt', '无此方法');
        }
    };
    NewsDownloader.prototype.pause = function () {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentNews) === null || _a === void 0 ? void 0 : _a.downloadApp_gdt) {
            var appInfo = __assign(__assign({}, this.newsAppInfo), { actionCode: 2 });
            window.TencentNews.invoke('downloadApp_gdt', JSON.stringify(appInfo), "downloadStatus");
        }
        else {
            errorLogger('异常:', 'downloadApp_gdt', '无此方法');
        }
    };
    NewsDownloader.prototype.resume = function () {
        this.start();
    };
    NewsDownloader.prototype.install = function () {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentNews) === null || _a === void 0 ? void 0 : _a.installApp) {
            window.TencentNews.invoke('installApp', JSON.stringify(this.newsAppInfo), "installCallback");
        }
        else {
            this.emit('install_error');
            errorLogger('异常:', 'installApp', '无此方法');
        }
    };
    NewsDownloader.prototype.open = function () {
        var _a, _b;
        var _c = this.opt, active = _c.active, packagename = _c.packagename;
        if (packagename === AppPackage.NEWS) {
            return location.href = active;
        }
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentNews) === null || _a === void 0 ? void 0 : _a.launchApp) {
            return window.TencentNews.invoke('launchApp', JSON.stringify(this.newsAppInfo));
        }
        else {
            errorLogger('异常:', 'launchApp', '无此方法');
        }
        if ((_b = window === null || window === void 0 ? void 0 : window.TencentNews) === null || _b === void 0 ? void 0 : _b.openApp) {
            return window.TencentNews.openApp(active, packagename);
        }
        else {
            errorLogger('异常:', 'openApp', '无此方法');
        }
        if (active) {
            return location.href = active;
        }
        location.href = createDeeplink(packagename);
    };
    NewsDownloader.prototype.isInstalled = function () {
        var _a;
        var packagename = this.opt.packagename;
        if (packagename === AppPackage.NEWS) {
            return true;
        }
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentNews) === null || _a === void 0 ? void 0 : _a.isAppInstalled) {
            return Number(window.TencentNews.isAppInstalled(packagename)) === 1;
        }
        return false;
    };
    // NewsType = {
    //     0：未下载
    //     1：下载中
    //     2：暂停下载
    //     3：下载完成
    //     4：正在安装
    //     5：安装完成/已安装
    //     6：安装失败
    //     7：需更新
    //     8：下载任务等待中
    //     9：下载失败
    // }
    NewsDownloader.prototype.getStatus = function () {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.newsDownloadStatus) === null || _a === void 0 ? void 0 : _a.status) {
            if (window.newsDownloadStatus.status === 9) {
                this.emit('apierror', window.newsDownloadStatus.status);
            }
            if (window.newsDownloadStatus.status === 6) {
                this.emit('install', window.newsDownloadStatus.status);
            }
            var statusInfo = [
                AppDownloadStatus.TASK_STATUS_NONE,
                AppDownloadStatus.TASK_STATUS_PROGRESS,
                AppDownloadStatus.TASK_STATUS_PROGRESS,
                AppDownloadStatus.TASK_STATUS_COMPLETED,
                AppDownloadStatus.TASK_STATUS_COMPLETED,
            ][window.newsDownloadStatus.status] || window.newsDownloadStatus.status;
            // 以QB和TBS的状态为准
            return statusInfo;
        }
        return AppDownloadStatus.TASK_STATUS_NONE;
    };
    NewsDownloader.prototype.getProgress = function () {
        var _a;
        return (_a = window === null || window === void 0 ? void 0 : window.newsDownloadStatus) === null || _a === void 0 ? void 0 : _a.progress;
    };
    return NewsDownloader;
}(EventEmitter));
export default NewsDownloader;
